export enum SettingEnum {
    USER_SHIPMENT_VIEWS = 'USER_SHIPMENT_VIEWS',
    MANAGED_SHIPMENT_VIEWS = 'MANAGED_SHIPMENT_VIEWS',
    DEFAULT_SHIPPER = 'DEFAULT_SHIPPER',
    DEFAULT_DESTINATION = 'DEFAULT_DESTINATION',
    DEFAULT_CURRENCY = 'DEFAULT_CURRENCY',
    DEFAULT_UNITS = 'DEFAULT_UNITS',
    USER_TIMEZONE = 'USER_TIMEZONE',
    USER_AVATAR = 'USER_AVATAR',
    IDENTITY_BANNER = 'IDENTITY_BANNER',
    IDENTITY_LOGO = 'IDENTITY_LOGO'
}
